// =============================================================================
// Exportação em CSV — Planilha orçamentária e Orçado vs Realizado
//
// Mesma convenção do modelo de importação (lib/planilha.ts): ponto e vírgula,
// que é o que o Excel em português abre já separado em colunas, e valor com
// vírgula decimal. O que se exporta é o que está FILTRADO na tela — a pessoa
// baixa o que está vendo, não a base inteira.
// =============================================================================

/** Centavos (string) → "1234,56", sem símbolo e sem separador de milhar.
 *  Sem milhar de propósito: "1.234,56" o Excel lê como texto em algumas
 *  configurações regionais, e a coluna deixa de somar. Vazio fica vazio. */
export function centavosParaCsv(centavos: string | null | undefined): string {
  if (centavos === null || centavos === undefined || centavos === "") return "";
  const n = BigInt(centavos);
  const neg = n < 0n;
  const abs = neg ? -n : n;
  return `${neg ? "-" : ""}${abs / 100n},${(abs % 100n).toString().padStart(2, "0")}`;
}

/** Aspas quando o campo tem separador, aspas ou quebra de linha (RFC 4180). */
function campo(v: string): string {
  return /[;"\r\n]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v;
}

export function montarCsv(linhas: string[][]): string {
  return linhas.map((l) => l.map(campo).join(";")).join("\r\n") + "\r\n";
}

/** Dispara o download. O BOM faz o Excel ler UTF-8 sem estragar os acentos. */
export function baixarCsv(nome: string, linhas: string[][]): void {
  const blob = new Blob(["﻿" + montarCsv(linhas)], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = nome;
  a.click();
  // Revogar no mesmo tick cancela o download em alguns navegadores.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
